import { StatusTypes } from '@/components/EditorBuilder/PowerUps/enums';
import { ContentType } from '@/components/EditorBuilder/types';
import { findContentByType, getBlockByType } from '@/components/EditorBuilder/utils';
import { Blocks } from '@/components/PageEditor/types';

import { EMPTY_ARTICLE_TITLE } from '../consts';
import {
  onArticleCoverPayloadType,
  onRenamePayloadType,
  onSetArticleCustomDurationSavePayloadType,
} from '../types';

export const getLessonDetails = (lessonContent?: ContentType[]) => {
  const lessonDetails = lessonContent?.reduce(
    (details, item) => {
      details[item.type] = item;
      return details;
    },
    {} as { [key: string]: ContentType },
  );

  return {
    title: lessonDetails?.[Blocks.TITLE]?.content?.[0]?.text ?? '',
    customDuration: lessonDetails?.[Blocks.REF]?.attrs?.customDuration ?? 0,
    updatedAt: lessonDetails?.[Blocks.REF]?.attrs?.updatedAt ?? '',
    description: lessonDetails?.[Blocks.DESCRIPTION]?.content?.[0]?.text ?? '',
    cover: {
      src: lessonDetails?.[Blocks.COVER]?.attrs?.src ?? '',
      yOffsetPercent: lessonDetails?.[Blocks.COVER]?.attrs?.yOffsetPercent ?? 0,
    },
    // it is lessonPageId as refType is ly__page
    lessonPageId: lessonDetails?.[Blocks.REF]?.attrs?.refId ?? '',
    refId: lessonDetails?.[Blocks.REF]?.attrs?.id ?? '',
    commentThreadId: lessonDetails?.[Blocks.LESSON_COMMENTS]?.attrs?.commentThreadId ?? '',
    assignee: { id: lessonDetails?.[Blocks.LESSON_ASSIGNEE]?.attrs?.userId },
    status: lessonDetails?.[Blocks.LESSON_STATUS]?.attrs?.status as StatusTypes,
    notes: lessonDetails?.[Blocks.LESSON_NOTES]?.content?.[0]?.text ?? '',
    uploadFileUserId: lessonDetails?.[Blocks.REF]?.attrs?.uploadFileUserId,
    uploadFileUrl: lessonDetails?.[Blocks.REF]?.attrs?.uploadFileUrl,
    uploadFileJobId: lessonDetails?.[Blocks.REF]?.attrs?.uploadFileJobId,
  };
};

export const onRenameSectionOrLesson = (
  payload: onRenamePayloadType,
  lessonContent?: ContentType[],
) => {
  const { value } = payload;
  const title = getBlockByType(lessonContent, Blocks.TITLE);
  if (title) {
    title.text = value || EMPTY_ARTICLE_TITLE;
  }
};

export const onSetLessonCover = (
  payload: onArticleCoverPayloadType,
  lessonContent?: ContentType[],
) => {
  const { picture, yOffsetPercent } = payload;
  const coverAttributes = findContentByType(lessonContent, Blocks.COVER)?.attrs;
  if (coverAttributes) {
    coverAttributes.src = picture;
    coverAttributes.yOffsetPercent = yOffsetPercent;
  }
};

export const onSetArticleCustomDurationSave = (
  payload: onSetArticleCustomDurationSavePayloadType,
  lessonContent?: ContentType[],
) => {
  const lessonPageAttributes = findContentByType(lessonContent, Blocks.REF)?.attrs;
  if (lessonPageAttributes) {
    lessonPageAttributes.customDuration = payload.customDuration;
  }
};
